import { Link } from 'react-router-dom';
import React from 'react';
import { getNameAvatarImage } from '../../../utils/HoaUtils';
import AvatarStatus, { AvatarStatusProps } from '../../../components/shared-components/AvatarStatus';
import { Member } from '@quick/client';
import { useCommunityPrefixPath } from '../../../hooks/Routing';
import { useIsAdmin } from '../../../redux/selector';

interface MemberAvatarProps extends Omit<AvatarStatusProps, 'src' | 'name'> {
  member: Member;
  showName?: boolean;
  showProperty?: boolean;
}

const MemberAvatar = ({ member, showProperty, showName = true, ...props }: MemberAvatarProps) => {
  const appPrefixPath = useCommunityPrefixPath();
  const isCurrentMemberAdmin = useIsAdmin();
  const avatar = (
    <AvatarStatus
      src={member.imageUrl ?? getNameAvatarImage(member.name)}
      name={showName && member.name}
      subtitle={showProperty ? member.property?.address : undefined}
      {...props}
    />
  );
  return isCurrentMemberAdmin ? (
    <Link to={`${appPrefixPath}/members/${member.memberId}`} style={{ color: 'inherit' }}>
      {avatar}
    </Link>
  ) : (
    avatar
  );
};

export default MemberAvatar;
